@if (viewingLatestRun) {
  <mode-view-page-banner status="warning">
    <h2 class="notice">The latest Report data was removed as a result of your Workspace’s data retention policy.</h2>

    <span>Refresh Report</span>
  </mode-view-page-banner>
} @else {
  <mode-view-page-banner status="warning">
    <h2 class="notice">
      You’re viewing a historic run from
      <span data-testid="historic-run-date">{{ formattedHistoricRunDate }}</span> that was removed as a result of your
      Workspace’s data retention policy.
    </h2>

    @if (moreRecentRunAvailable) {
      <a [href]="latestDataUrl" class="view-latest">View the latest data</a>
    } @else {
      <span>Refresh Report</span>
    }
  </mode-view-page-banner>
}
